import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '什么是前列腺高潮？',
    answer: '前列腺高潮是通过刺激前列腺（男性特有的生殖腺体）引发的强烈性快感体验。与传统的阴茎高潮不同，前列腺高潮通常被描述为更深层、更全身性、更持久的快感浪潮。它可能伴随或不伴随射精，且部分男性可以在较短时间内体验多次前列腺高潮。',
  },
  {
    question: '每个男性都能体验前列腺高潮吗？',
    answer: '从解剖学角度，每个前列腺结构正常的男性都有可能通过适当的刺激感受到某种程度的快感。但实际能否达到高潮取决于多种因素，包括神经敏感性的个体差异、心理准备程度、练习技巧以及放松程度等。建议以探索和学习的心态去尝试，而非执着于特定结果。',
  },
  {
    question: '前列腺刺激安全吗？',
    answer: '在遵循安全操作规范的前提下，前列腺刺激是相对安全的。关键安全原则包括：排除禁忌症、使用充足润滑、控制力度轻柔、控制操作时间（10-20分钟）、保持卫生。但急性前列腺炎、尿路感染、前列腺脓肿等急性疾病期间绝对禁止进行前列腺刺激。',
  },
  {
    question: '前列腺刺激对健康有好处吗？',
    answer: '多项医学研究表明，规律、规范的前列腺刺激可能带来多种健康益处，包括改善慢性前列腺炎症状、促进前列腺液排泄和代谢、改善盆底肌肉功能等。但需要注意，这些益处建立在安全规范操作的基础上，不当操作反而可能导致健康问题。',
  },
  {
    question: '多大年龄开始关注前列腺健康比较合适？',
    answer: '前列腺健康是所有成年男性都应关注的话题。建议从25-30岁开始建立基本的健康意识，包括健康饮食和规律运动。从45岁开始（有家族史者从40岁开始）建议每年进行前列腺特异性抗原（PSA）检测和直肠指诊筛查。',
  },
  {
    question: '前列腺高潮会影响性取向吗？',
    answer: '不会。前列腺是每个男性都有的正常解剖结构，对自身身体的探索和认知与性取向无关。科学研究反复证明，前列腺快感与性取向之间没有任何因果关联。这是一种基于解剖学的生理反应，而非性取向的指标。',
  },
];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              常见问题解答
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              快速了解关于前列腺健康最常见的疑问
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <i
                    className={`text-foreground-400 text-lg transition-transform flex-shrink-0 ${
                      openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                {openIndex === index && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}